@if (isVisible) {
  <div class="demo-controls" aria-label="Demo controls">
    <!-- Style/Theme Selector -->
    <div class="style-toggle">
      <label for="styleSelect">Style:</label>
      <select id="styleSelect" [value]="selectedTheme" (change)="onThemeChange($event)">
        @for (theme of availableThemes; track theme) {
          <option [value]="theme.id">{{ theme.name }}</option>
        }
      </select>
    </div>

    <!-- Upload Theme Button -->
    <div class="style-toggle upload-toggle">
      <button
        type="button"
        class="upload-theme-btn"
        (click)="onUploadThemeClick()"
        aria-label="Upload theme"
      >
        Upload Theme
      </button>
      <input
        id="themeUploadInput"
        type="file"
        accept=".json,application/json"
        (change)="onThemeFileSelected($event)"
        style="display: none;"
        aria-hidden="true"
      />
      <button
        type="button"
        class="upload-theme-btn preview-upload-btn"
        (click)="onPreviewUploadClick()"
        aria-label="Preview upload theme"
      >
        Preview Upload
      </button>
      <input
        id="themePreviewUploadInput"
        type="file"
        accept=".json,application/json"
        (change)="onPreviewThemeFileSelected($event)"
        style="display: none;"
        aria-hidden="true"
      />
      @if (uploadError) {
        <span class="upload-error" role="alert">{{ uploadError }}</span>
      }
    </div>

    <!-- Auto-sequence Selector -->
    <div class="style-toggle seq-toggle">
      <label for="seqSelect">Auto-sequence:</label>
      <select id="seqSelect" [value]="autoSequence" (change)="onAutoSequenceChange($event)" aria-label="Auto-sequence">
        <option value="off">Off</option>
        <option value="on">On</option>
      </select>
    </div>

    <!-- Logo Toggle -->
    <div class="style-toggle logo-toggle">
      <label for="logoSelect">Logo:</label>
      <select id="logoSelect" [value]="logoEnabled" (change)="onLogoToggle($event)" aria-label="Hotel logo">
        <option value="off">Off</option>
        <option value="on">On</option>
      </select>
    </div>

    <!-- Logo URL Input (shown when logo is enabled) -->
    <div class="style-toggle logo-url-toggle" id="logoUrlWrap" [hidden]="logoEnabled === 'off'">
      <label for="logoUrlInput">Logo URL:</label>
      <input
        id="logoUrlInput"
        type="text"
        [(ngModel)]="logoUrl"
        (change)="onLogoUrlChange()"
        placeholder="https://…"
        autocomplete="off"
        spellcheck="false"
        />
      </div>
    </div>

  <!-- Upload Theme Modal -->
  @if (showUploadModal) {
    <app-upload-theme-modal
      [deltaRows]="uploadDeltaRows"
      [mode]="uploadMode"
      [themeName]="uploadThemeName"
      [version]="uploadVersion"
      (modeChange)="onUploadModeChange($event)"
      (themeNameChange)="onUploadThemeNameChange($event)"
      (confirm)="onConfirmUpload($event)"
      (cancel)="onCancelUpload()"
    />
  }
  }
